var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 20V12H18V20C18 21.1046 17.1046 22 16 22C14.8954 22 14 21.1046 14 20V10C14 8.89543 14.8954 8 16 8H48C49.1046 8 50 8.89543 50 10V20C50 21.1046 49.1046 22 48 22C46.8954 22 46 21.1046 46 20Z",
    fill: "#7681FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36C49.1046 36 50 36.8954 50 38V55C50 56.1046 49.1046 57 48 57H16C14.8954 57 14 56.1046 14 55V38C14 36.8954 14.8954 36 16 36H48ZM18 53H46V40H18V53Z",
    fill: "#7681FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55 24C55 23.0501 54.0969 22.0004 52.6758 22H11.3242C9.90309 22.0004 9 23.0501 9 24V42H16C17.1046 42 18 42.8954 18 44C18 45.1046 17.1046 46 16 46H7C5.89543 46 5 45.1046 5 44V24C5 20.5504 7.99611 18.0004 11.3242 18H52.6758C56.0039 18.0004 59 20.5504 59 24V44C59 45.1046 58.1046 46 57 46H48C46.8954 46 46 45.1046 46 44C46 42.8954 46.8954 42 48 42H55V24Z",
    fill: "#7681FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 32C48.6569 32 50 30.6569 50 29C50 27.3431 48.6569 26 47 26C45.3431 26 44 27.3431 44 29C44 30.6569 45.3431 32 47 32Z",
    fill: "#7681FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterIcon);
export default __webpack_public_path__ + "static/media/printer-icon.1892ac6d7b2aff400c8338ad679b014b.svg";
export { ForwardRef as ReactComponent };